import React, { ForwardRefExoticComponent, FunctionComponent, memo, ReactNode } from 'react';

import accordion from '../ProgressAccordion/ProgressAccordion.module.scss';
import styles from './Questionnaire.module.scss';

export type QuestionnaireFieldType = {
  name: string;
  required: boolean;
  label?: string;
  placeholder?: string;
  rules?: Record<string, string>;
  component?: ForwardRefExoticComponent<unknown>;
  conditional?: boolean;
};

export type QuestionnairePageOptions = {
  uuid: string;
  title: string;
  // List of fieldNames. If all the required fields
  // are correct => the "Next" button will be enabled
  fields: QuestionnaireFieldType[];
  customFooter?: ReactNode;
  children?: ReactNode;
  showTitle?: boolean;
};

export type QuestionnairePageProps = QuestionnairePageOptions & {
  id: number;
};

const QuestionnairePage: FunctionComponent<QuestionnairePageProps> = memo(
  ({ id, title, customFooter, children, showTitle = false }) => (
    <div className={styles.questionnaire__page}>
      {(!customFooter || showTitle) && (
        <div className={accordion.questionnaire__label}>
          <div className={accordion['questionnaire__label-content']} data-testid="questionnaire-title">
            <span>{id + 1}</span> {title}
          </div>
        </div>
      )}
      <div className={styles.questionnaire__content}>{children}</div>
    </div>
  )
);

QuestionnairePage.displayName = 'QuestionnairePage';

export default QuestionnairePage;
